import React, { FC } from 'react';
import { Gallery } from 'react-photoswipe-gallery';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import {
  useInspectionsVehiclesNotes,
  useInspectionsVehiclesMechanicalsNotes,
} from '@/api/Inspections';
import { CustomCard, LightBoxItem } from '@/ui/components';
import { useTranslate } from '@/translations';

import { ReplaceImageType } from '@/utils/constants';
import { useAppCustomers } from '@/hooks';
import { InspectionTabCard } from '../../InspectionTabCard';

import { InspectionPageTab } from '../types';
import { InspectionUpdateMileage } from '../../InspectionMileage';
import { AppFeatures } from '@/types';

export const Inspection: FC<InspectionPageTab> = ({
  inspection,
  canEditInspection,
}) => {
  const { t } = useTranslate();
  const { id } = useParams();
  const { hasSuperAdminAccess, hasFeatureAccess } = useAppCustomers();
  const inspectionNotes = useInspectionsVehiclesNotes(Number(id));
  const mechanicalsNotes = useInspectionsVehiclesMechanicalsNotes(Number(id));

  const { ...inspectionNote } = inspectionNotes.data?.entities[0] || {};
  const { ...mechanicalNote } = mechanicalsNotes.data?.entities[0] || {};

  const showOdometer = hasFeatureAccess(AppFeatures.InspectionTabOdometer);
  const showNotes = hasFeatureAccess(AppFeatures.InspectionTabInspectionNotes);
  const showMechanicalNotes = hasFeatureAccess(
    AppFeatures.InspectionTabMechanicalInspectionNotes,
  );

  const col =
    24 / [showOdometer, showNotes, showMechanicalNotes].filter((o) => o).length;

  return (
    <Row gutter={16}>
      {showOdometer ? (
        <Col xs={24} lg={col}>
          <div className="fw-semibold mb-3">{t('odometer')}</div>
          <CustomCard>
            <InspectionUpdateMileage
              inspection={inspection}
              canEdit={canEditInspection}
            />
            <Gallery>
              <LightBoxItem
                image={{
                  replaceImage: {
                    id: inspection.id,
                    type: ReplaceImageType.Odometer,
                  },
                  imageFileUrl: inspection.odometerImageFileName,
                  thumbnailImageUrl: inspection.odometerResizedImageUrl,
                }}
                actions={{
                  replaceImage: hasSuperAdminAccess ? () => {} : undefined,
                }}
              />
            </Gallery>
          </CustomCard>
        </Col>
      ) : null}
      {showNotes ? (
        <Col xs={24} lg={col}>
          <InspectionTabCard
            header={t('inspectionNotes')}
            data={inspectionNote}
            noDataMessage={t('noNotes')}
          />
        </Col>
      ) : null}
      {showMechanicalNotes ? (
        <Col xs={24} lg={col}>
          <InspectionTabCard
            header={t('mechanicalInspectionNotes')}
            data={mechanicalNote}
            noDataMessage={t('noNotes')}
          />
        </Col>
      ) : null}
    </Row>
  );
};
